/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createMutationHook } from '../../core/factories/createMutation.js';
import type { WaitlistPositionResponse, WaitlistPositionVars } from '../openapi-types.gen.js';

export type { WaitlistPositionResponse, WaitlistPositionVars } from '../openapi-types.gen.js';

export const useWaitlistPosition = createMutationHook<WaitlistPositionVars, WaitlistPositionResponse, unknown>({
  specName: 'useWaitlistPosition',
  path: '/v1/notifications/mainnet/waitlist/position',
  method: 'POST',
  resolveUrl: (vars: WaitlistPositionVars) => `/v1/notifications/mainnet/waitlist/position`,
  buildBody: (vars: WaitlistPositionVars) => ({ token: vars.token }),
  parseResponse: (raw: unknown): WaitlistPositionResponse => raw as WaitlistPositionResponse,
  
  
  
});
